import { TFunction } from 'react-i18next';
import { VehicleInfo } from 'types/Apis/VehicleApiResponse';

export interface VehicleInfoRows {
  make: Record<string, string>;
  model: Record<string, string>;
  trim: Record<string, string>;
  year: Record<string, string | number>;
  bodyStyle: Record<string, string>;
  doors: Record<string, string | number>;
  stock: Record<string, string>;
  vin: Record<string, string>;
}

export type VehicleRowConfig = {
  key: string;
  sections: Record<string, string | number>[];
}[];

export const getVehicleInfoRows = (
  vehicle: VehicleInfo,
  t: TFunction<'translation', undefined>
): VehicleInfoRows => ({
  make: {
    title: `${t(`quickView.make`)}:`,
    content: vehicle.make,
  },
  model: {
    title: `${t(`quickView.model`)}:`,
    content: vehicle.model,
  },
  trim: {
    title: `${t(`quickView.trim`)}:`,
    content: vehicle.trim,
  },
  year: {
    title: `${t(`quickView.year`)}:`,
    content: vehicle.year,
  },
  bodyStyle: {
    title: `${t(`quickView.bodyStyle`)}:`,
    content: vehicle.bodyStyle?.toUpperCase(),
  },
  doors: {
    title: `${t(`quickView.doors`)}:`,
    content: vehicle.doors,
  },
  stock: {
    title: `${t(`quickView.stockNumber`)}:`,
    content: vehicle.stockNumber,
  },
  vin: {
    title: `${t(`quickView.vin`)}:`,
    content: vehicle.vin,
  },
});

export const getVehicleRowConfig = (
  isMobile: boolean,
  vehicleInfoRows: VehicleInfoRows
): VehicleRowConfig =>
  isMobile
    ? [
        {
          key: 'makeModel',
          sections: [
            vehicleInfoRows.make,
            vehicleInfoRows.model,
            vehicleInfoRows.trim,
            vehicleInfoRows.year,
            vehicleInfoRows.bodyStyle,
            vehicleInfoRows.doors,
            vehicleInfoRows.stock,
            vehicleInfoRows.vin,
          ],
        },
      ]
    : [
        {
          key: 'makeBodyStyle',
          sections: [vehicleInfoRows.make, vehicleInfoRows.bodyStyle],
        },
        {
          key: 'modelDoors',
          sections: [vehicleInfoRows.model, vehicleInfoRows.doors],
        },
        {
          key: 'trimStock',
          sections: [vehicleInfoRows.trim, vehicleInfoRows.stock],
        },
        {
          key: 'yearVin',
          sections: [vehicleInfoRows.year, vehicleInfoRows.vin],
        },
      ];
